import { memo } from 'react';
import { LanguageSelector } from './LanguageSelector';
import { ThemeToggle } from './ThemeToggle';

const PublicSideHeader = memo(function PublicSideHeader() {
  return (
    <header className="flex h-16 shrink-0 items-center gap-2 px-4 md:px-6">
      <div className="flex h-(--header-height) w-full items-center justify-between gap-2">
        <div className="flex items-center gap-4 w-full"></div>
        <div className="flex items-center gap-3">
          <ThemeToggle />
          <LanguageSelector />
        </div>
      </div>
    </header>
  );
});

export default PublicSideHeader;
